import styled from "styled-components";

/**
 * Provides basic CSS for a section like Top Left or Top Right
 */
export const GamePlayPcHeaderBarSectionBaseBox = styled.div`
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  flex-grow: 1;
  flex-shrink: 1;
  height: 100%;
`